<template>
  <div class="desc">
    <div class="container">
      <div class="progress-bar">
        <p class="bar-b"><img src="../../assets/images/jdt-1@2x.png" alt="" class="bar"></p>
        <div class="txt">
          <div class="t1">
            <h3 class="title">登录企业网银</h3>
            <p class="t">电脑登陆企业网银后，进入[客户服务]-[微信注册]</p>
          </div>
          <div class="t1">
            <h3 class="title">扫描二维码</h3>
            <p class="t">点击下方【绑定】按钮，扫描网银画面上的二维码</p>
          </div>
          <div class="t1">
            <h3 class="title">输入动态密码</h3>
            <p class="t">请在网银页面输入您的邮箱收到的动态密码</p>
          </div>
          <div class="t1">
            <h3 class="title tit">点击【确定】按钮完成</h3>
          </div>
        </div>
      </div>
      <div class="btn" @click="close">确定</div>
    </div>
  </div>


</template>

<script>
import wx from 'weixin-js-sdk'
export default {
  name: 'desc',
    data(){
        return{
            orderData:"",  //接收酷屏通过URL传过来的数据
            configContent: {}
        }
    },
    methods: {
      // 调用wx接口要获取的数据
      queryScanQRCodeInfo(){
        let reqHead = {
            // orderNo:val,
            // TransId:"QueryIpayOrder",
        }
        let url = location.href.split('#')[0]
        let reqBody = {}
        let params = {
          url:url
        }
        this.$api.post("/queryScanQRCodeInfo.do",params).then(res => {
          this.configContent = res
          console.log(this.configContent)
           this.signWX()
        })
      },
      // 调微信扫一扫
      signWX () {
        let _this = this
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: this.configContent.appid, // 必填，公众号的唯一标识
          timestamp: this.configContent.timestamp, // 必填，生成签名的时间戳
          nonceStr: this.configContent.nonceStr, // 必填，生成签名的随机串
          signature: this.configContent.signature, // 必填，签名
          jsApiList: ['closeWindow'] // 必填，需要使用的JS接口列表
        })
      },
      close() {
        wx.ready(function () {
          wx.closeWindow()
        });
      }
    },
    mounted () { // 刚进来页面就检查wx配置
      this.queryScanQRCodeInfo()
    },
    created () {
    },
}
</script>

<style scoped>
.desc{
  background-color: #efeff4;
  height: 100%;
  padding-top: 30px;
}
.container{
  background-color: #efeff4;
  height: 100%;
  padding-top: 30px;
  position: relative;
}
.progress-bar{
  padding:90px 45px 0;
  height: 788px;
  display: flex;
  background-color: #fff;
  box-shadow: 10px 0px 20px #888888;
}
.bar-b{
  width: 40px;
  margin: 0;
}
.bar{
  width: 40px;
  height: 550px;
}
.txt{
  flex: 1;
  margin-left:70px;
}
.title{
  font-size: 30px;
  font-weight: bold;
  color: #007C7D;
}
.t1{

}
.t1 .title{
  margin:5px 0 40px;
  font-size: 30px;
  font-weight: bold;
  color: #000000;
  opacity: 0.8;
}
.t1 .tit{
  color: #007C7D;
}
.t1 .t{
  margin:25px 0 20px;
  font-size: 26px;
  font-weight: bold;
  color: #000000;
  opacity: 0.7;
}
.btn{
  font-size: 40px;
  font-weight: bold;
  color: #FFFFFF;
  width: 650px;
  height: 90px;
  text-align: center;
  line-height: 90px;
  border-radius: 45px;
  margin: 60px auto 0;
  background-color: #007C7D;
}
</style>



// WEBPACK FOOTER //
// src/views/desc/desc.vue